<template>
    <!--
          作者：kmdshop
          时间：2019-10-24
          描述：后台系统首页
      -->
      <div  v-if="!loading" >
        <div v-if="obj.citySupplyDistrict.length > 0">
          <div class="common-form">我管理的城市</div>
          <div>
              <div v-for="(item,index) in obj.citySupplyDistrict" :key="index"
                style="font-size: 14px; color: #029eff; float: left;margin-left: 10px;margin-bottom: 10px;">
                {{ item.name }}
              </div>
              <div style="clear: both;"></div>

          </div>
      </div>
    <div>
      <div class="home-index">

        <div style="display: flex;width: 100%;margin-left: 7%;">
          <div class="main-index">
      
      <el-row>
        <el-col :span="6" >
          <div class="grid-content">
            <div class="pic">
                <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>
            <div class="info" @click="jump('/plus/warehouse_management/index')">
                <h3>{{ form.rk_stock }}</h3>
              <a class="des" style="color: #029eff;">入库库存</a>
            </div>
          </div>
        </el-col> 
        
        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
              <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>
            <div class="info" @click="jump('/plus/out_management/index')">
                <h3>{{  form.ck_stock }}</h3>
              <a class="des" style="color: #029eff;">出库库存</a>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
                <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>

            <div class="info" @click="jump('/plus/warehouse_inventory/index')">
                <h3 v-if="form.rk_stock && form.ck_stock">{{ form.rk_stock - form.ck_stock  }}</h3>
              <a class="des" style="color: #029eff;">总库存</a>
            </div>
          </div>
        </el-col>




  
  

      </el-row>
    </div>

    <div style="flex: 1;">
      <el-form size="small" ref="form" :model="form" >
  
          <el-form-item label="七天库存总数">
                <el-input placeholder="请输入七天库存总数" v-model="form.stock_num" style="width: 300px;"></el-input>
          </el-form-item>


            
          <el-form-item label="起始时间">
            <div class="block">
              <span class="demonstration"></span>
              <el-date-picker
                size="small"
                v-model="form.create_time"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 300px;"
              ></el-date-picker>
            </div>
          </el-form-item>  
          <el-form-item>
      <el-button type="primary" icon="el-icon-search" @click="onSubmit">设置</el-button>
    </el-form-item>





  



</el-form>

    </div>
  </div>

      
      

     
      
      </div>
 
      
      <div class="home-index">
      
      <div class="main-index">
      
      <el-row class="border-b">
        <el-col :span="6" >
          <div class="grid-content">
            <div class="pic">
                <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>
            <div class="info" @click="jump('/plus/supply/index')">
                <h3>{{ obj.supply_num }}</h3>
              <a class="des" style="color: #029eff;">供应商</a>
            </div>
          </div>
        </el-col> 
        
        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
              <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>
            <div class="info" @click="jump('/plus/supply/index')">
                <h3>{{ obj.shop_num }}</h3>
              <a class="des" style="color: #029eff;">商家</a>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
                <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>

            <div class="info" @click="jump('/plus/driver/index')">
                <h3>{{ obj.driver_user }}</h3>
              <a class="des" style="color: #029eff;">司机</a>
            </div>
          </div>
        </el-col>


        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
                <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>

            <div class="info" @click="jump('/plus/saler/index')">
                <h3>{{ obj.saler_user }}</h3>
              <a class="des" style="color: #029eff;">业务员</a>
            </div>
          </div>
        </el-col>
  
  

      </el-row>
    </div>
   </div>




         
   <div class="home-index">
      
      <div class="main-index">
      
      <el-row class="border-b">
        <el-col :span="6" >
          <div class="grid-content">
            <div class="pic">
                <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>
            <div class="info" @click="jump('/order/order/index')">
                <h3>{{ obj.order_num }}</h3>
              <a class="des" style="color: #029eff;">订单</a>
            </div>
          </div>
        </el-col> 
        
        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
              <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>
            <div class="info" @click="jump('/order/order/genindex')">
                <h3>{{ obj.dd_num }}</h3>
              <a class="des" style="color: #029eff;">发货单</a>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
                <Icon :iconname="'#icon-xiaoshou'"></Icon>
            </div>

            <div class="info" @click="jump('/plus/driver/index')">
                <h3>{{ obj.line_num }}</h3>
              <a class="des" style="color: #029eff;">线路</a>
            </div>
          </div>
        </el-col>


  

      </el-row>
    </div>
   </div>
      
      
      <div class="home-index">
        
      
        <!--main-index-->
        <div class="main-index">
       
          <el-row class="border-b">
            <el-col :span="6">
              <div class="grid-content">
                <div class="pic">
                  <Icon :iconname="'#icon-xiaoshou'"></Icon>
                </div>
                <div class="info">
                  <h3>{{ obj.total_inventory }}</h3>
                  <p class="des">库存总量</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <div class="pic">
                    <Icon :iconname="'#icon-xiaoshou'"></Icon>
                </div>

                <div class="info" @click="jump('/plus/existing_inventory/index')">
                    <h3>{{ obj.available_inventory }}</h3>
                  <a class="des" style="color: #029eff;">可用库存</a>
                </div>
              </div>
            </el-col>
            <el-col :span="6" >
              <div class="grid-content">
                <div class="pic">
                    <Icon :iconname="'#icon-xiaoshou'"></Icon>
                </div>
                <div class="info" @click="jump('/plus/warning_inventory/index')">
                    <h3>{{ obj.inventory_warning }}</h3>
                  <a class="des" style="color: #029eff;">库存预警</a>
                </div>
              </div>
            </el-col>

          </el-row>
        </div>


   
  
        <!--side-->
        <div class="side"></div>
      </div>



  
  
    </div>
     
    </div>
  </template>
  
  <script>
  import Existing_inventoryApi from '@/api/existing_inventory.js';
  
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        obj:{
            total_inventory:0,
            available_inventory:0,
            inventory_warning:0,
        },
        form:{
          status:false,
          stock_num:0,
        }
  
      };
    },
  
  
    created() {
      /*获取数据*/
      this.getData();
      this.getSetting();
    },
    methods: {
      
      /*获取数据*/
      getData() {
        let self = this;
        Existing_inventoryApi.getCount({})
          .then((data) => {
            self.loading = false;
            self.obj = data.data;
          })
          .catch((error) => {});
      },
      /*点击菜单跳转*/
      goto(item) {
        if (item != null) {
          let path = item;
          this.$router.push(path);
        } else {
          this.$router.push("/");
        }
      },
      jump(url){
        this.$router.push({
            path: url,
            query: {
            is_show:1
            }
        });
      },
      /*跳转图片*/
      gotoImg(item) {
        window.open(item);
      },



          /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      Existing_inventoryApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      Existing_inventoryApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '设置成功',
              type: 'success'
            });
            self.getSetting();
            self.getData();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .operation-wrap {
    width: 100%;
  
    border-radius: 8px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 0 30px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    background: #3a8ee6;
    background-size: 100% 100%;
    color: #fff;
  
  }
  
  .operation-wrap .grid-content {
    height: 164px;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .operation-wrap .grid-content h3 {
    font-size: 36px;
    line-height: 40px;
  }
  
  .operation-wrap .grid-content .info {
    margin-left: 10px;
  }
  
  .operation-wrap .grid-content .svg-icon {
    color: #ffffff;
  }
  
  .home-index {
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    min-width: 1000px;
    overflow-x: auto;
  }
  
  .main-index {
    flex: 1;
  }
  
  .main-index .grid-content,
  .operation-wrap .grid-content {
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  
  .main-index .grid-content {
    height: 120px;
  }
  
  .main-index .grid-content .pic {
    margin-right: 10px;
  }
  
  .main-index .grid-content h3 {
    font-size: 20px;
    font-weight: normal;
  }
  
  .main-index .grid-content .yesterday {
    color: #ccc;
  }
  
  .main-index .grid-content .svg-icon {
    color: #3a8ee6;
  }
  
  .matters-wrap .matters {
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 120px;
  }
  
  .matters-wrap .matters .title {
    font-size: 14px;
    color: #fff;
    display: inline-block;
    height: 20px;
    line-height: 20px;
    width: 40px;
    text-align: center;
    border-radius: 99px;
    margin-bottom: 20px;
    background: #3a8ee6;
  }
  
  .matters-wrap .matters ul {
    color: #999999;
  }
  
  .matters-wrap .matters ul span {
    padding-right: 6px;
    color: #3a8ee6;
  }
  
  .markert-wrap .market {
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
  .markert-wrap .market-box {
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px 20px;
  }
  .markert-wrap .market-box .el-image {
    width: 150px;
    height: 150px;
    margin-bottom: 2px;
  
  }
  
  .markert-wrap .market-box p {
    font-size: 14px;
    color: #999999;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/home/panel.vue